import RegisterMain from '@/components/RegAndForgot/RegisterMain';
export default function Register() {
    const element = (
        <>
            <RegisterMain />
        </>
    );
    return element;
}